import React, { useState, useEffect } from 'react';
import HttpHelper from "../service/httpService";
import { LuLeafyGreen } from 'react-icons/lu';
import { handleImageError } from 'base/Utility'
const FactSheet = (props) => {
    const [factSheetData, setFactSheetData] = useState([]);
    const [factSheetDataN, setFactSheetDataN] = useState([]);

    const getFactSheetData = async () => {
        await HttpHelper.get("website/GetFactSheet").then((response) => {
            if (response.status === 200) {
                setFactSheetData(response.data);
            }

            var tt = handleImageError(null);
        }).catch((error) => {
            console.log(error)
        })
    }

    const getFactsheetDataPrint = () => {

        return (<>
            {factSheetData.length > 0 && factSheetData.map((e, i) => {
                return (<>
                    <div className="col-md-12 mb-10 text-vertical-center-justified justified-content-center">
                        <div>
                            {
                                e.factsheetHeading ?
                                    <div class="portfolio-main-info"><h2 class="title text-center">{e.factsheetHeading}</h2></div>
                                    : ''
                            }
                            <h2 className="text-center">{e.heading}</h2>
                            <p className="text-center"><strong>{e.imgHeading}</strong></p>
                            <div className="work-details-list mt-10 alignImages" >
                                {e.file == null ?
                                    <img className="resize-image" src={process.env.REACT_APP_PUBLIC_URL + '/assets/images/Missing.jpg'} alt="No image found" height="300" />
                                    :
                                    <img className="resize-image" src={e.file && e.file.fileUrl} onError={handleImageError} height="300" />
                                }
                            </div>
                            <div className="mt-10" dangerouslySetInnerHTML={{ __html: e.content }} />
                        </div>
                    </div>
                </>)
            })}
        </>)
    }

    useEffect(() => {
        getFactSheetData();
    }, [])

    return (<>
        <div className={`section section-padding FactsheetReverseColumn ${props.bgClass}`}>
            <div className="container pt--100 pb--80 col-lg-8">
                <div className="row">
                    <div className="col-md-12">
                        <div className="portfolio-main-info">
                            <h2 className="title text-center">{props.title}</h2>
                        </div>
                    </div>
                </div>
                {getFactsheetDataPrint()}
            </div>
        </div>
    </>)
}

export default FactSheet;